import { getFormValues } from 'redux-form'
import { TABLA_MENU_DE_MUESTRAS } from '../../../../../config/tables'
import { FORM_LISTADO_MUESTRAS_ENVIADAS } from '../../../../../config/forms'
import { Muestras } from '../../../../../models/calado/menu_muestras_llamados'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'
import { COLUMNS_MENU_DE_MUESTRAS, COLUMNS_MENU_DE_MUESTRAS_TO_PRINT } from './constantesMenuDeMuestrasTabla'
import moment from 'moment'

export function actualizarDatosParaMuiTable (onSucces) {
  return (dispatch, getState) => {
    const state = getState()
    const muestraValues = getFormValues(FORM_LISTADO_MUESTRAS_ENVIADAS)(state)
    if (muestraValues) {
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          isLoading: true
        },
        id: TABLA_MENU_DE_MUESTRAS
      })
      if (muestraValues.numero !== undefined) {
        Muestras.getMuestrasPorNumero(muestraValues.numero).then(callback)
      } else if (muestraValues.muestra !== undefined) {
        const muestra = parseInt(muestraValues.muestra / 100 % 10000000000)
        Muestras.getMuestrasPorMuestra(muestra).then(callback)
      } else if (muestraValues.fechaD !== null && muestraValues.fechaH !== null) {
        const fechaD = moment(muestraValues.fechaD).format('YYYY-MM-DD')
        const fechaH = moment(muestraValues.fechaH).format('YYYY-MM-DD')
        Muestras.getMuestrasPorFechas(fechaD, fechaH).then(callback)
      }
      onSucces()
    }
    function callback (data) {
      // console.log(data)
      const customToolbar = pdfCustomToolbarGenerator(
        'Consulta de Muestras',
        data || [],
        COLUMNS_MENU_DE_MUESTRAS_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_MENU_DE_MUESTRAS,
          data: data,
          title: `Consulta de Muestras`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: { customToolbar, print: false }
        },
        id: TABLA_MENU_DE_MUESTRAS
      })
    }
  }
}

export function updateDatosParaMuiTable (newState) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState,
      id: TABLA_MENU_DE_MUESTRAS
    })
  }
}
